import React, { useCallback, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveSidebarData } from 'store/actions/scenariosActions.action';
import { SideBarContext } from 'components/ScenarioSetup/ActionSidebars/context/SideBarContext';
import { SidebarGeneralTitle } from 'common/SidebarGeneral/SidebarGeneralTitle';
import { Label } from 'common/_Label/Label';
import { InputField } from 'common/InputField/InputField';
import { ErrorMessageField } from 'common/ErrorMessageField/ErrorMessageField';
import { useTranslation } from 'react-i18next';
import { ActionSidebarButtons } from 'components/ScenarioSetup/ActionSidebars/SidebarComponents/ActionSidebarButtons';
import { ActionSidebarFormWrapper } from 'common/Forms/ActionSidebarFormWrapper';
import { getStoreDataWait } from 'store/selectors/scenariosActions.selectors';
import { useAutoSaveActionSetting } from 'hooks/ScenarioSetup/useAutoSaveActionSetting';
import { InputTimeField } from 'common/InputTimeField/InputTimeField';
import { Checkbox } from 'common/_Checkbox/Checkbox';

export const WaitSidebar = () => {
    const dispatch = useDispatch();
    const { title, _values, _minDispatchTime, _maxDispatchTime, actionType, errors } = useSelector(getStoreDataWait);
    const { t: translator } = useTranslation();

    const {
        onChangeNumericInput,
        onChangeTime,
        onSubmitHandler,
        onChangeCheckbox,
    } = useContext(SideBarContext);

    const [values, setValues] = useState(_values);
    const [minDispatchTime, setMinDispatchTime] = useState(_minDispatchTime);
    const [maxDispatchTime, setMaxDispatchTime] = useState(_maxDispatchTime);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChangeCached = useCallback(onChangeNumericInput(setValues), []);

    const onChangeTimeInput = useCallback(setState => onChangeTime(setState), [onChangeTime]);

    const saveData = {
        values,
        minDispatchTime,
        maxDispatchTime,
    };

    const onClickSaveActionSettings = () => dispatch(saveSidebarData(saveData));

    useAutoSaveActionSetting(onClickSaveActionSettings, actionType);

    return (
        <ActionSidebarFormWrapper onSubmitCallback={onSubmitHandler(onClickSaveActionSettings)}>
            <>
                <SidebarGeneralTitle title={title}/>

                <Label htmlFor='waitInterval' text={translator('actionSidebars:waitInterval')}/>
                <InputField
                    type='number'
                    id='waitInterval'
                    name='waitInterval'
                    value={values?.waitInterval?.value}
                    required={values?.waitInterval?.required}
                    error={!!errors?.waitInterval}
                    onChange={onChangeCached}
                />
                <ErrorMessageField active={!!errors?.waitInterval} message={errors?.waitInterval}/>

                <Checkbox
                    id='useTimeInterval'
                    name='useTimeInterval'
                    label={translator('actionSidebars:useTimeInterval')}
                    checked={values?.useTimeInterval}
                    onChange={onChangeCheckbox(setValues)}
                    isShowCheckboxLabelValue
                />

                {values.useTimeInterval &&
                    <React.Fragment>
                        <InputTimeField
                            value={minDispatchTime}
                            onChange={onChangeTimeInput(setMinDispatchTime)}
                            label={translator('actionSidebars:TimeFieldLabel')}
                            title={translator('actionSidebars:MinDispatchTime')}
                        />

                        <InputTimeField
                            value={maxDispatchTime}
                            onChange={onChangeTimeInput(setMaxDispatchTime)}
                            label={translator('actionSidebars:TimeFieldLabel')}
                            title={translator('actionSidebars:MaxDispatchTime')}
                        />
                    </React.Fragment>
                }

                <ActionSidebarButtons/>
            </>
        </ActionSidebarFormWrapper>
    );
};
